import { render, staticRenderFns } from "./TkHotelFilterSidebar.vue?vue&type=template&id=45b09b78&"
import script from "./TkHotelFilterSidebar.vue?vue&type=script&lang=js&"
export * from "./TkHotelFilterSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports